import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

import App from './App.vue';
import { router } from './router';
import SvgIcon from './components/icons/SvgIcon.vue';
import './styles.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(ElementPlus);
app.component('SvgIcon', SvgIcon);
app.mount('#app');
